import type { ProgramSection } from '@educator/components/ProgramSections/types/sections'

/**
 * Falls back to the local order whenever the layout would render nothing, so an
 * unseeded or unreachable backend never ships a blank page.
 */
export const orderProgramSections = (
  sections: readonly ProgramSection[],
  order: readonly string[] | null | undefined,
): ProgramSection[] => {
  if (!order?.length) return [...sections]

  const sectionsById = new Map(sections.map((section) => [section.id, section]))
  const ordered = [...new Set(order)].flatMap((slug) => {
    const section = sectionsById.get(slug)
    return section ? [section] : []
  })

  return ordered.length ? ordered : [...sections]
}
